import { render } from "./QuotaCreditTab.vue?vue&type=template&id=1db0c2c2&scoped=true"
import script from "./QuotaCreditTab.vue?vue&type=script&lang=js"
export * from "./QuotaCreditTab.vue?vue&type=script&lang=js"

import "./QuotaCreditTab.vue?vue&type=style&index=0&id=1db0c2c2&lang=scss&scoped=true"

import exportComponent from "/home/pedro/git/cloudstack/scclouds/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1db0c2c2"]])

export default __exports__